import { Component, OnInit } from '@angular/core';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';
import { FlexDirective } from '@ngbracket/ngx-layout/flex';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { MatDivider } from '@angular/material/divider';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-is-maes-gwirio',
    templateUrl: './is-maes-gwirio.component.html',
    styleUrls: ['./is-maes-gwirio.component.scss'],
    imports: [FlexDirective, FaIconComponent, MatDivider, FormlyModule, TranslatePipe]
})
export class IsMaesGwirioComponent extends FieldArrayType implements OnInit {

  constructor() {
    super();
  }

  ngOnInit(): void {

  }
}
